import { useState, useEffect, useRef } from 'react';

export const useTypewriter = (text: string, enabled: boolean, speed: number = 12) => {
  const [displayedText, setDisplayedText] = useState(enabled ? '' : text);
  const [isTyping, setIsTyping] = useState(enabled);
  const hasTyped = useRef(false);
  const activeTextRef = useRef(text);
  const intervalRef = useRef<number | null>(null);
  const isTypingRef = useRef(false);

  useEffect(() => {
    if (text !== activeTextRef.current) {
      activeTextRef.current = text;
      hasTyped.current = false;
      if (intervalRef.current !== null) {
        window.clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      isTypingRef.current = false;
    }

    if (!enabled) {
      if (!isTypingRef.current) {
        setDisplayedText(text);
        setIsTyping(false);
      }
      return;
    }

    if (hasTyped.current || isTypingRef.current) {
      return;
    }

    setDisplayedText('');
    setIsTyping(true);
    isTypingRef.current = true;
    let i = 0;

    if (intervalRef.current !== null) {
      window.clearInterval(intervalRef.current);
    }

    intervalRef.current = window.setInterval(() => {
      i++;
      setDisplayedText(text.slice(0, i));
      if (i >= text.length) {
        if (intervalRef.current !== null) {
          window.clearInterval(intervalRef.current);
        }
        intervalRef.current = null;
        setIsTyping(false);
        hasTyped.current = true;
        isTypingRef.current = false;
      }
    }, speed);
  }, [text, enabled, speed]);

  useEffect(() => {
    return () => {
      if (intervalRef.current !== null) {
        window.clearInterval(intervalRef.current);
      }
      intervalRef.current = null;
      isTypingRef.current = false;
    };
  }, []);

  return { displayedText, isTyping };
};
